/**
 * Logo Carousel JavaScript - Infinite Scroll Version
 * Handles carousel functionality with cloned items for seamless infinite scrolling
 */

var carouselStates = {};

function initCarousel(sectionId) {
  if (!carouselStates[sectionId]) {
    carouselStates[sectionId] = {
      currentSlide: 0,
      totalSlides: 0,
      originalSlides: 0,
      slidesPerView: 1,
      autoPlayInterval: null,
      isTransitioning: false,
      clonesAdded: false
    };
  }
  
  const carousel = document.getElementById('carousel-' + sectionId);
  if (!carousel) return;
  
  const track = carousel.querySelector('.logo-carousel__track');
  const originalSlides = track.querySelectorAll('.logo-carousel__slide');
  
  // Get data attributes
  const totalSlides = parseInt(carousel.dataset.totalSlides) || originalSlides.length;
  const slidesMobile = parseInt(carousel.dataset.slidesMobile) || 2;
  const slidesTablet = parseInt(carousel.dataset.slidesTablet) || 3;
  const slidesDesktop = parseInt(carousel.dataset.slidesDesktop) || 5;
  
  const state = carouselStates[sectionId];
  state.originalSlides = totalSlides;
  state.slidesMobile = slidesMobile;
  state.slidesTablet = slidesTablet;
  state.slidesDesktop = slidesDesktop;
  
  // Add clones for infinite scroll
  addClonedSlides(sectionId);
  
  updateSlidesPerView(sectionId);
  
  // Set initial position to first real slide (after leading clones)
  state.currentSlide = state.slidesPerView;
  updateCarouselPosition(sectionId, false);
  
  // Auto-play functionality
  const autoPlay = carousel.dataset.autoplay === 'true';
  const speed = parseInt(carousel.dataset.speed) || 4000;
  
  if (autoPlay && totalSlides > state.slidesPerView) {
    startAutoPlay(sectionId, speed);
    
    carousel.addEventListener('mouseenter', () => stopAutoPlay(sectionId));
    carousel.addEventListener('mouseleave', () => startAutoPlay(sectionId, speed));
  }
  
  // Add resize listener with debounce
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateSlidesPerView(sectionId);
    }, 150);
  });

  // Add touch/swipe support for mobile
  addTouchSupport(sectionId);
}

function addClonedSlides(sectionId) {
  const carousel = document.getElementById('carousel-' + sectionId);
  if (!carousel) return;
  
  const track = carousel.querySelector('.logo-carousel__track');
  const state = carouselStates[sectionId];
  
  // Don't add clones if already added
  if (state.clonesAdded) return;
  
  const originalSlides = Array.from(track.querySelectorAll('.logo-carousel__slide'));
  const slidesToShow = Math.max(state.slidesMobile, state.slidesTablet, state.slidesDesktop);
  
  // Only add clones if we have enough slides to make infinite scroll meaningful
  if (originalSlides.length <= slidesToShow) {
    state.totalSlides = originalSlides.length;
    return;
  }
  
  // Clone slides for infinite effect
  // Add clones at the beginning (for seamless backward scroll)
  const leadingClones = originalSlides.slice(-slidesToShow).map(slide => {
    const clone = slide.cloneNode(true);
    clone.classList.add('logo-carousel__clone', 'logo-carousel__clone--leading');
    return clone;
  });
  
  // Add clones at the end (for seamless forward scroll)
  const trailingClones = originalSlides.slice(0, slidesToShow).map(slide => {
    const clone = slide.cloneNode(true);
    clone.classList.add('logo-carousel__clone', 'logo-carousel__clone--trailing');
    return clone;
  });
  
  // Insert leading clones at the beginning
  leadingClones.forEach(clone => {
    track.insertBefore(clone, track.firstChild);
  });
  
  // Append trailing clones at the end
  trailingClones.forEach(clone => {
    track.appendChild(clone);
  });
  
  // Update total slides count (including clones)
  state.totalSlides = track.querySelectorAll('.logo-carousel__slide').length;
  state.clonesAdded = true;
}

function updateSlidesPerView(sectionId) {
  const carousel = document.getElementById('carousel-' + sectionId);
  if (!carousel) return;
  
  const state = carouselStates[sectionId];
  const width = window.innerWidth;
  let slidesPerView = 1;
  
  if (width > 1200) {
    slidesPerView = state.slidesDesktop;
  } else if (width >= 750) {
    slidesPerView = state.slidesTablet;
  } else {
    slidesPerView = state.slidesMobile;
  }
  
  const prevSlidesPerView = state.slidesPerView;
  state.slidesPerView = slidesPerView;
  
  // Adjust current position if slides per view changed
  if (prevSlidesPerView !== slidesPerView && state.clonesAdded) {
    // Ensure we're still showing a real slide (not clone)
    const realSlideIndex = (state.currentSlide - slidesPerView) % state.originalSlides;
    state.currentSlide = slidesPerView + Math.max(0, realSlideIndex);
  }
  
  updateCarouselPosition(sectionId, false);
  updateDotsVisibility(sectionId);
}

function moveCarousel(sectionId, direction) {
  const state = carouselStates[sectionId];
  if (!state || state.isTransitioning) return;
  
  // If no clones (not enough slides), use regular movement
  if (!state.clonesAdded) {
    moveCarouselRegular(sectionId, direction);
    return;
  }
  
  state.isTransitioning = true;
  state.currentSlide += direction;
  
  updateCarouselPosition(sectionId, true, () => {
    // Handle infinite loop reset
    const slidesToShow = state.slidesPerView;
    
    // If we've moved past the last real slide (into trailing clones)
    if (state.currentSlide >= state.originalSlides + slidesToShow) {
      state.currentSlide = slidesToShow;
      updateCarouselPosition(sectionId, false);
    }
    // If we've moved before the first real slide (into leading clones)
    else if (state.currentSlide < slidesToShow) {
      state.currentSlide = state.originalSlides + slidesToShow - 1;
      updateCarouselPosition(sectionId, false);
    }
    
    updateDots(sectionId);
    state.isTransitioning = false;
  });
}

function moveCarouselRegular(sectionId, direction) {
  const state = carouselStates[sectionId];
  
  // Regular movement for when there aren't enough slides for infinite scroll
  const maxSlide = Math.max(0, state.originalSlides - state.slidesPerView);
  
  state.currentSlide += direction;
  
  if (state.currentSlide < 0) {
    state.currentSlide = maxSlide;
  } else if (state.currentSlide > maxSlide) {
    state.currentSlide = 0;
  }
  
  updateCarouselPosition(sectionId, true);
  updateDots(sectionId);
  
  setTimeout(() => {
    state.isTransitioning = false;
  }, 300);
}

function goToSlide(sectionId, slideIndex) {
  const state = carouselStates[sectionId];
  if (!state || state.isTransitioning) return;
  
  state.isTransitioning = true;
  
  if (state.clonesAdded) {
    // Convert dot index to actual slide position (account for leading clones)
    state.currentSlide = state.slidesPerView + slideIndex;
  } else {
    const maxSlide = Math.max(0, state.originalSlides - state.slidesPerView);
    state.currentSlide = Math.max(0, Math.min(slideIndex, maxSlide));
  }
  
  updateCarouselPosition(sectionId, true);
  updateDots(sectionId);
  
  setTimeout(() => {
    state.isTransitioning = false;
  }, 300);
}

function updateCarouselPosition(sectionId, animate = true, callback = null) {
  const carousel = document.getElementById('carousel-' + sectionId);
  if (!carousel) return;
  
  const track = carousel.querySelector('.logo-carousel__track');
  const state = carouselStates[sectionId];
  
  // Calculate the exact percentage to move
  const slideWidth = 100 / state.slidesPerView;
  const translateX = -(state.currentSlide * (100 / state.slidesPerView));
  
  // Apply transition only if animate is true
  if (animate) {
    track.style.transition = 'transform 0.3s ease';
    if (callback) {
      // Remove transition after animation and call callback
      setTimeout(() => {
        track.style.transition = 'none';
        callback();
        // Re-enable transition for next move
        setTimeout(() => {
          track.style.transition = 'transform 0.3s ease';
        }, 50);
      }, 300);
    }
  } else {
    track.style.transition = 'none';
    setTimeout(() => {
      track.style.transition = 'transform 0.3s ease';
    }, 50);
  }
  
  track.style.transform = `translateX(${translateX}%)`;
}

function updateDots(sectionId) {
  const carousel = document.getElementById('carousel-' + sectionId);
  if (!carousel) return;
  
  const dots = carousel.querySelectorAll('.logo-carousel__dot');
  const state = carouselStates[sectionId];
  
  if (!state.clonesAdded) {
    // Regular dot update for non-infinite carousel
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === state.currentSlide);
    });
    return;
  }
  
  // Calculate which real slide we're showing (excluding clones)
  const realSlideIndex = (state.currentSlide - state.slidesPerView) % state.originalSlides;
  const normalizedIndex = realSlideIndex < 0 ? state.originalSlides + realSlideIndex : realSlideIndex;
  
  dots.forEach((dot, index) => {
    dot.classList.toggle('active', index === normalizedIndex);
  });
}

function updateDotsVisibility(sectionId) {
  const carousel = document.getElementById('carousel-' + sectionId);
  if (!carousel) return;
  
  const dotsContainer = carousel.querySelector('.logo-carousel__dots');
  const state = carouselStates[sectionId];
  
  if (dotsContainer) {
    // Hide dots if all slides are visible
    if (state.originalSlides <= state.slidesPerView) {
      dotsContainer.style.display = 'none';
    } else {
      dotsContainer.style.display = 'flex';
    }
  }
}

function startAutoPlay(sectionId, speed) {
  stopAutoPlay(sectionId);
  
  const state = carouselStates[sectionId];
  if (state.originalSlides <= state.slidesPerView) return;
  
  state.autoPlayInterval = setInterval(() => {
    moveCarousel(sectionId, 1);
  }, speed);
}

function stopAutoPlay(sectionId) {
  const state = carouselStates[sectionId];
  if (state && state.autoPlayInterval) {
    clearInterval(state.autoPlayInterval);
    state.autoPlayInterval = null;
  }
}

function addTouchSupport(sectionId) {
  const carousel = document.getElementById('carousel-' + sectionId);
  if (!carousel) return;
  
  const track = carousel.querySelector('.logo-carousel__track');
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  
  track.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
    track.style.transition = 'none';
  });
  
  track.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    
    currentX = e.touches[0].clientX;
    const diffX = currentX - startX;
    
    // Add some resistance
    if (Math.abs(diffX) > 50) {
      e.preventDefault();
    }
  });
  
  track.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    
    isDragging = false;
    track.style.transition = 'transform 0.3s ease';
    
    const diffX = currentX - startX;
    const threshold = 50;
    
    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        moveCarousel(sectionId, -1); // Swipe right - go to previous
      } else {
        moveCarousel(sectionId, 1);  // Swipe left - go to next
      }
    }
    
    startX = 0;
    currentX = 0;
  });
}

// Initialize all carousels when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('[id^="carousel-"]');
  carousels.forEach(carousel => {
    const sectionId = carousel.id.replace('carousel-', '');
    initCarousel(sectionId);
  });
});

// Re-initialize on theme editor updates
document.addEventListener('shopify:section:load', function(event) {
  const carousel = event.target.querySelector('[id^="carousel-"]');
  if (carousel) {
    const sectionId = carousel.id.replace('carousel-', '');
    // Reset state before reinitializing
    if (carouselStates[sectionId]) {
      stopAutoPlay(sectionId);
      delete carouselStates[sectionId];
    }
    initCarousel(sectionId);
  }
});

// Cleanup on section unload
document.addEventListener('shopify:section:unload', function(event) {
  const carousel = event.target.querySelector('[id^="carousel-"]');
  if (carousel) {
    const sectionId = carousel.id.replace('carousel-', '');
    stopAutoPlay(sectionId);
    delete carouselStates[sectionId];
  }
});

// Handle keyboard navigation
document.addEventListener('keydown', function(event) {
  const activeCarousel = document.querySelector('.logo-carousel:hover [id^="carousel-"]');
  if (!activeCarousel) return;
  
  const sectionId = activeCarousel.id.replace('carousel-', '');
  
  if (event.key === 'ArrowLeft') {
    event.preventDefault();
    moveCarousel(sectionId, -1);
  } else if (event.key === 'ArrowRight') {
    event.preventDefault();
    moveCarousel(sectionId, 1);
  }
});